import React from 'react';
import { TrendingUp, Target, BarChart3, Zap, Activity, Users, BoxIcon } from 'lucide-react';
interface FeatureListItemProps {
  icon: 'trending' | 'target' | 'chart' | 'zap' | 'activity' | 'users';
  title: string;
  description: string;
  isActive: boolean;
  onClick: () => void;
}
const iconMap: Record<string, BoxIcon> = {
  trending: TrendingUp,
  target: Target,
  chart: BarChart3,
  zap: Zap,
  activity: Activity,
  users: Users
};
/**
 * FeatureListItem component
 * Clickable feature item in the left sidebar
 * Shows icon, title, and description with active state
 */
export function FeatureListItem({
  icon,
  title,
  description,
  isActive,
  onClick
}: FeatureListItemProps) {
  const Icon = iconMap[icon];
  return <button onClick={onClick} className={`
        w-full text-left p-6 rounded-xl border transition-all duration-300
        ${isActive ? 'bg-[#3ab795]/10 border-[#3ab795] shadow-[0_0_24px_rgba(58,183,149,0.2)]' : 'bg-[#1a1a1a]/50 border-white/10 hover:border-[#3ab795]/40 hover:bg-[#1a1a1a]/80'}
        group cursor-pointer
      `} data-id="element-252">
      {/* Icon and Title */}
      <div className="flex items-start gap-4 mb-3" data-id="element-253">
        <div className={`
          flex-shrink-0 w-12 h-12 rounded-xl flex items-center justify-center transition-all duration-300
          ${isActive ? 'bg-[#3ab795] shadow-[0_4px_16px_rgba(58,183,149,0.4)]' : 'bg-[#3ab795]/10 group-hover:bg-[#3ab795]/20'}
        `} data-id="element-254">
          <Icon className={`w-6 h-6 transition-colors ${isActive ? 'text-white' : 'text-[#3ab795]'}`} strokeWidth={2.5} data-id="element-255" />
        </div>

        <div className="flex-1 min-w-0" data-id="element-256">
          <h3 className={`
            text-lg font-bold mb-2 transition-colors
            ${isActive ? 'text-[#3ab795]' : 'text-white group-hover:text-[#3ab795]'}
          `} data-id="element-257">
            {title}
          </h3>
          <p className="text-sm text-[#b8bcc8] leading-relaxed" data-id="element-258">
            {description}
          </p>
        </div>
      </div>

      {/* Active indicator */}
      {isActive && <div className="mt-4 pt-4 border-t border-[#3ab795]/20" data-id="element-259">
          <div className="flex items-center gap-2 text-xs text-[#3ab795] font-medium" data-id="element-260">
            <div className="w-1.5 h-1.5 rounded-full bg-[#3ab795] animate-pulse" data-id="element-261" />
            <span data-id="element-262">Viewing in dashboard</span>
          </div>
        </div>}
    </button>;
}